import { useAuthStore } from "../store/authStore";

export const usePermission = (moduleName: string) => {
  const { user } = useAuthStore() as any;

  // Varsayılan yetkiler (Eğer session yoksa)
  if (!user) return { canRead: false, canCreate: false, canUpdate: false, canDelete: false };

  // Super Admin her yetkiye sahiptir
  if (user.role?.name === "super_admin") {
    return { canRead: true, canCreate: true, canUpdate: true, canDelete: true };
  }

  // Kullanıcının rolüne ait permissions dizisinden ilgili modülü bul
  const perm = user.role?.permissions?.find((p: any) => p.module === moduleName);

  return {
    canRead: !!perm?.canRead,
    canCreate: !!perm?.canCreate,
    canUpdate: !!perm?.canUpdate,
    canDelete: !!perm?.canDelete,
  };
};